import { Component, OnInit } from '@angular/core';
import { BookingEmailHistory } from '../booking-email-history';
import { Country } from '../country';
import { HttpService } from '../service/http.service';
import { InternalBookingComment } from '../internal-booking-comment';
import { LanguageCourse } from '../language-course';
import { School } from '../school';
import { BookingSummaryService } from '../service/booking-summary.service';
import { BookingService } from '../service/booking.service';
import { ToastMessageService } from '../toast-message.service';
import { UserService } from '../service/user.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-booking-summary',
  templateUrl: './booking-summary.component.html',
  styleUrls: ['./booking-summary.component.css']
})
export class BookingSummaryComponent implements OnInit {

  courseDescriptionHasNoTranslation = false;

  constructor(
    public bookingService: BookingService,
    public userService: UserService,
    public bookingSummaryService: BookingSummaryService,
    private httpService: HttpService,
    private confirmationService: ConfirmationService,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
    this.verifyCourseTranslation(this.bookingService.booking.languageCourse);
  }

  updateProgrammeInformationList(school: School) {
    this.bookingService.updateProgrammeInformationList(school.id!, this.bookingService.booking.student.language);
  }
  updateSchools(destination: Country) {
    this.httpService.getSchoolsByDestination(destination.id).subscribe(res => {
      this.bookingService.schoolList = res;
      let currentSchool = this.bookingService.bookingForm.get("school")!.value;
      if (currentSchool != null) {
        for (let school of res) {
          if (school.id == currentSchool.id) {
            return;
          }
        }
        this.bookingService.bookingForm.get("school")!.setValue(null);
      }
    });
  }

  updateLanguageCourses(newSchool: School) {
    this.httpService.getLanguageCoursesBySchoolId(newSchool.id!).subscribe(res => {
      this.bookingService.languageCourseList = res;
      this.bookingService.bookingForm.get("languageCourse")!.setValue(this.bookingService.languageCourseList[0]);
    });
  }
  updateProgrammeTypes(newSchool: School) {
    this.httpService.getProgrammeTypesBySchoolId(newSchool.id!).subscribe(res => {
      this.bookingService.programmeTypes = res;
      this.bookingService.bookingForm.get("programmeType")!.setValue(this.bookingService.programmeTypes[0]);
    });
  }
  updateGoogleSheetUrl(school: School) {
    this.httpService.getGoogleSheetUrl(school.id!).subscribe(res => {
      this.bookingService.googleSheetPriceUrl = res;
    });
  }

  updateCancellationInsuranceSuppliers() {
    if (this.bookingService.cancellationInsuranceSuppliers.length == 0 && this.bookingService.bookingForm.get("cancellationInsuranceRequested")!.value) {
      this.httpService.getCancellationInsuranceSuppliers().subscribe(res => {
        this.bookingService.cancellationInsuranceSuppliers = res;
      });
    }
  }

  updateTravelInsuranceSuppliers() {
    if (this.bookingService.travelInsuranceSuppliers.length == 0 && this.bookingService.bookingForm.get("travelInsuranceRequested")!.value) {
      this.httpService.getTravelInsuranceSuppliers().subscribe(res => {
        this.bookingService.travelInsuranceSuppliers = res;
      });
    }
  }

  deleteComment(comment: InternalBookingComment) {
    this.confirmationService.confirm({
      header: "Delete your post",
      message: "Do you want to delete your post ID: " + comment.id + "?",
      accept: () => {
        this.httpService.deleteInternalBookingComment(comment.id!).subscribe(() => {
          this.bookingService.booking.internalCommentList = this.bookingService.booking.internalCommentList.filter((item) => {
            return item.id != comment.id;
          });
          this.toastService.addSuccess("Success", "Your post is deleted !");
        }, error => {
          this.toastService.addError("Error", error.error.message);
        });
      }
    })
  }

  activateEmailHistoryDetail(selectedEmail: BookingEmailHistory) {
    this.bookingService.selectedEmailHistory = selectedEmail;
    this.bookingService.displayMailHistoryDetail = true;
  }

  languageCourseChange(selectedCourse: LanguageCourse) {
    this.verifyCourseTranslation(selectedCourse);
  }

  verifyCourseTranslation(course: LanguageCourse) {
    if (!course) {
      return;
    }
    if (!this.bookingService.booking.student.language) {
      return;
    }
    switch (this.bookingService.booking.student.language.id) {
      case 1:
        if (!course.descriptionFr) {
          this.courseDescriptionHasNoTranslation = true;
        }
        break;
      case 2:
        if (!course.descriptionEn) {
          this.courseDescriptionHasNoTranslation = true;
        }
        break;
      case 3:
        if (!course.descriptionNl) {
          this.courseDescriptionHasNoTranslation = true;
        }
        break;
      case 4:
        if (!course.descriptionEs) {
          this.courseDescriptionHasNoTranslation = true;
        }
        break;
      case 5:
        if (!course.descriptionPt) {
          this.courseDescriptionHasNoTranslation = true;
        }
        break;
    }
  }

}
